// There are other plaid errors, but only these will be relevant to us on this page
// We should move these to a config somewhere.
const plaidError = {
  // API ERRORS
  INTERNAL_SERVER_ERROR: "INTERNAL_SERVER_ERROR",
  PLANNED_MAINTENANCE: "PLANNED_MAINTENANCE",
  // INSTITUTION ERRORS
  INSTITUTION_DOWN: "INSTITUTION_DOWN",
  INSTITUTION_NOT_RESPONDING: "INSTITUTION_NOT_RESPONDING",
  INSTITUTION_NOT_AVAILABLE: "INSTITUTION_NOT_AVAILABLE",
  INSTITUTION_NO_LONGER_SUPPORTED: "INSTITUTION_NO_LONGER_SUPPORTED",
  // ITEM ERRORS
  INVALID_CREDENTIALS: "INVALID_CREDENTIALS",
  INVALID_MFA: "INVALID_MFA",
  INVALID_SEND_METHOD: "INVALID_SEND_METHOD",
  INVALID_UPDATED_USERNAME: "INVALID_UPDATED_USERNAME",
  ITEM_LOCKED: "ITEM_LOCKED",
  ITEM_LOGIN_REQUIRED: "ITEM_LOGIN_REQUIRED",
  ITEM_NOT_SUPPORTED: "ITEM_NOT_SUPPORTED",
  ITEM_NO_VERIFICATION: "ITEM_NO_VERIFICATION",
  INCORRECT_DEPOSIT_AMOUNTS: "INCORRECT_DEPOSIT_AMOUNTS",
  RATE_LIMIT_EXCEEDED: "RATE_LIMIT_EXCEEDED",
  TOO_MANY_VERIFICATION_ATTEMPTS: "TOO_MANY_VERIFICATION_ATTEMPTS",
  USER_SETUP_REQUIRED: "USER_SETUP_REQUIRED",
  MFA_NOT_SUPPORTED: "MFA_NOT_SUPPORTED",
  NO_ACCOUNTS: "NO_ACCOUNTS",
  NO_AUTH_ACCOUNTS: "NO_AUTH_ACCOUNTS"
};

const plaidErrorDescription = {
  // API ERRORS
  [plaidError.INTERNAL_SERVER_ERROR]:
    "Plaid was unable to process the request, either due to an internal system issue or an unsupported response from a financial institution.",
  [plaidError.PLANNED_MAINTENANCE]:
    "Plaid's systems are in maintenance mode and API operations are disabled. Please try again later, or contact our support team.",
  // INSTITUTION ERRORS
  [plaidError.INSTITUTION_DOWN]:
    "The financial institution is down, either for maintenance or due to an infrastructure issue with their systems. Please try again later, or contact our support team.",
  [plaidError.INSTITUTION_NOT_RESPONDING]:
    "The financial institution is failing to respond to some of our requests. Please try again.",
  [plaidError.INSTITUTION_NOT_AVAILABLE]:
    "The financial institution is not available this time. Please try again later, or contact our support team.",
  [plaidError.INSTITUTION_NO_LONGER_SUPPORTED]:
    "Plaid no longer supports this financial institution. Please choose a different bank to link.",
  // ITEM ERRORS
  [plaidError.INVALID_CREDENTIALS]:
    "The financial institution indicated that the credentials provided were invalid.",
  [plaidError.INVALID_MFA]:
    "The financial institution indicated that the MFA response(s) provided were invalid.",
  [plaidError.INVALID_SEND_METHOD]:
    "Plaid could not match up the MFA OTP send method to one of the ones we sent to you, or the institution rejected it as invalid for some reason. Please contact support.",
  [plaidError.INVALID_UPDATED_USERNAME]:
    "The username provided in update mode via Link did not match the original username for the Item. Please try again, or contact our support team.",
  [plaidError.ITEM_LOCKED]:
    "The financial institution indicated that your account is locked. You will need to work with the institution directly to unlock your account.",
  [plaidError.ITEM_LOGIN_REQUIRED]:
    "The financial institution indicated that your password or MFA information has changed. You will need to reauthenticate.",
  [plaidError.ITEM_NOT_SUPPORTED]:
    "Plaid is unable to support yours accounts due to restrictions in place at your financial institution. Please contact support.",
  [plaidError.ITEM_NO_VERIFICATION]:
    "Plaid is unable to support your accounts due to restrictions in place at the financial institution. Please contact support.",
  [plaidError.INCORRECT_DEPOSIT_AMOUNTS]:
    "Incorrect Manual Same-Day micro-deposit amounts submitted.",
  [plaidError.RATE_LIMIT_EXCEEDED]: "Error: Credentials were invalid",
  [plaidError.TOO_MANY_VERIFICATION_ATTEMPTS]:
    "You attempted to verify Manual Same-Day micro-deposit amounts more than 3 times for an Item. The Item is now permanently locked and you must retry with a new institution.",
  [plaidError.USER_SETUP_REQUIRED]:
    "You must log in directly to the financial institution and take some action (agree to updated terms and conditions, change your password, etc.) before we can add your accounts.",
  [plaidError.MFA_NOT_SUPPORTED]:
    "You have required a form of MFA that Plaid does not support for a given financial institution.",
  [plaidError.NO_ACCOUNTS]: "You have no open accounts at this institution",
  [plaidError.NO_AUTH_ACCOUNTS]:
    "Sorry! We don't support that institution at this time."
};

const CURRENT_DDA_FLOOR = `$1,000`;

export { plaidError, plaidErrorDescription, CURRENT_DDA_FLOOR }